import React from "react";
import "../../App.css";
import ImageGrid from "../ImageGrid";
import Sidebar from "../Sidebar";

export default function MemesForSale() {
  return (
    <>
      <div className="dashboard">
        <ImageGrid />
        <Sidebar />
      </div>
      {/* <h1 className="memesforsale">Upload your meme</h1>;
      <UploadMeme /> 
      <h2>New upload image thing</h2>
      <UploadImage />*/}
      {}
    </>
  );
}
